import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  DecreaseValueIcon,
  IncreaseValueIcon,
  ProductivityModalCrossIcon,
} from "../common/Icon";
import { useStateProvider } from "../common/StateProvider";
import { TodayProductivityCards } from "../common/Helper";

export const TodayProductivityModel = ({
  todayProductivityModel,
  setTodayProductivityModel,
  indexValue,
  setCardArray,
}) => {
  const { counterValue, setCounterValue, setSaveValueCounter } =
    useStateProvider();

  const [inputValue, setInputValue] = useState(""); // Add this state variable

  const increaseValue = () => {
    setCounterValue(parseInt(counterValue) + 1);
  };

  const decreaseValue = () => {
    if (counterValue > 0) {
      setCounterValue(counterValue - 1);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setCounterValue(value);
  };

  const saveHandler = () => {
    setTodayProductivityModel(false);
    setSaveValueCounter(counterValue);
    const updatedTodayProductivityCards = [...TodayProductivityCards];
    updatedTodayProductivityCards[indexValue].contactpercent = counterValue;
    setCardArray(updatedTodayProductivityCards);
  };
  // Update the counterValue in the modal when it changes
  useEffect(() => {
    setCounterValue(counterValue);
  }, [counterValue]);

  return (
    <>
      <Transition appear show={todayProductivityModel} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-[99999999]"
          onClose={() => {
            setTodayProductivityModel(false);
          }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <div className="fixed inset-0 bg-[#0d10143d]" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div
              className="flex min-h-full items-center justify-center text-center"
              onClick={() => {
                setTodayProductivityModel(false);
                setCounterValue(0);
              }}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="overflow-hidden transition-all">
                  <div className="w-full max-w-[330px] md:max-w-[406px] bg-white text-center py-8 px-9 z-10 relative rounded-xl mx-auto text-white">
                    <div
                      className="absolute top-2 right-2 cursor-pointer"
                      onClick={() => {
                        setTodayProductivityModel(false);
                        setCounterValue(0);
                      }}>
                      <ProductivityModalCrossIcon />
                    </div>
                    <h4 className="text-sm text-black  font-bold mb-5">
                      How many contacts would you like to add today?
                    </h4>
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={decreaseValue}
                        className=" bg-transparent outline-none">
                        <DecreaseValueIcon />
                      </button>
                      {/* <span className="text-sm font-bold text-black border border-solid border-[rgba(111,_106,_248,_0.30)] rounded-lg value_bg_color w-full max-w-[90px] py-3">
                        {counterValue}
                      </span> */}
                      <input
                        className="text-sm font-bold outline-none text-center text-black border border-solid border-[rgba(111,_106,_248,_0.30)] rounded-lg value_bg_color w-full max-w-[90px] py-3"
                        type="text"
                        value={counterValue}
                        onChange={handleInputChange} // Add this line
                      />
                      <button
                        onClick={increaseValue}
                        className=" bg-transparent outline-none">
                        <IncreaseValueIcon />
                      </button>
                    </div>
                    <button
                      onClick={saveHandler}
                      type="submit"
                      className="text-sm text-white font-bold mt-6 p-[6px_20px] bg-primary rounded-[37px] border border-soild border-transparent hover:bg-transparent hover:text-primary hover:border-primary duration-200">
                      Save
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
